<template>
    <div v-if="usps.length > 0" class="mt-5 w-full space-y-1 py-0.5">
        <div v-for="usp in usps" :key="`configurable_product_usp_${usp.label}`" class="flex w-full items-start gap-1">
            <CheckIcon class="not-sr-only size-5 shrink-0 stroke-[2.5px] text-usp-checkmark" />
            <span class="usp-item" @click="visitInternalLink" v-html="usp.label" />
        </div>
    </div>
</template>

<script setup lang="ts">
import { useProductPageStore } from '@/stores/pages/ProductPageStore';
import { visitInternalLink } from '@/utils/inertiaLinkClick';
import { CheckIcon } from '@lucide/vue';
import { computed } from 'vue';

const productPageStore = useProductPageStore();
const usps = computed(() => productPageStore.configurableProduct.usps);
</script>
